// extracted by mini-css-extract-plugin
module.exports = {"recentAction":"RecentActionsCard_recentAction__wNvNI","wrapper":"RecentActionsCard_wrapper__UoSPq","isMobile":"RecentActionsCard_isMobile__TTrCM"};